<template>
  <TextShrinker :value="user.bio" @click="openBioSidebar">
    <template v-slot="{ text }">
      <div class="profile__user__quote">{{ text }}</div>
    </template>

    <template #buttonText>ver bio</template>
  </TextShrinker>
</template>

<script>
import { mapActions } from 'vuex'
import TextShrinker from '@/components/misc/TextShrinker'

export default {
  components: {
    TextShrinker,
  },

  props: {
    user: { type: Object, required: true }
  },


  methods: {
    ...mapActions('slideSidebar', ['slideSidebarShow']),

    openBioSidebar () {
      this.slideSidebarShow({
        name: 'user/UserBioSidebar',
        direction: 'right',
        props: { user: this.user }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .profile__user__quote { 
    
  }
</style>